import { render, staticRenderFns } from "./FormDinamic.vue?vue&type=template&id=179c4ca2"
import script from "./FormDinamic.vue?vue&type=script&lang=js"
export * from "./FormDinamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports